import { RSAA, getJSON } from 'redux-api-middleware';
import { checkEmptyFieldValue, getQueryStringValueByName } from '../../utils';
import * as analytics from '../../utils/analytics';
import { ANALYTICS_ERROR, CASE_ID, BUSINESS_UUID } from '../../utils/constants';
import { technicalErrorPage } from '../../store/dataCapture/actions';
import { updateCasePayload } from './updateCasePayload';

export const FETCH_CASE = 'FETCH_CASE';
export const FETCH_CASE_SUCCESS = 'FETCH_CASE_SUCCESS';
export const FETCH_CASE_FAILED = 'FETCH_CASE_FAILED';
export const UPDATE_CASE = 'UPDATE_CASE';
export const UPDATE_CASE_FAILED = 'UPDATE_CASE_FAILED';
export const UPDATE_CASE_SUCCESS = 'UPDATE_CASE_SUCCESS';

export const fetchCase = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current/${getQueryStringValueByName(
      CASE_ID
    )}/tasks/capture`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: FETCH_CASE,
        meta: { loading: true }
      },
      {
        type: FETCH_CASE_SUCCESS,
        payload: (_action, _state, res) =>
          getJSON(res).then((json) => {
            res.json = json;
            return json;
          }),
        meta: (_action, _state, res) => {
          const businessId = res.json.customer_id.business;
          updateAnalytics(res.json);
          if (checkEmptyFieldValue(businessId)) {
            return { nextAction: getBusinessDetails(businessId), loading: true };
          }
          return { loading: false };
        }
      },
      {
        type: FETCH_CASE_FAILED,
        meta: () => {
          analytics.error({ errorCode: 0, errorMessage: ANALYTICS_ERROR.FETCH_CASE_FAILED });
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

const updateAnalytics = (res) => {
  analytics.updateCase(getQueryStringValueByName(CASE_ID));
  analytics.updateApplicant();
  if (res && res.applicant && res.applicant.joint_link_code) {
    analytics.updateApplicant(res.applicant.joint_link_code);
  }
  if (res && res.product && res.product.variant) {
    analytics.updateBusinessType(res.product.variant);
  }
};

export const FETCH_BUSINESS_CUSTOMERSBYID = 'FETCH_BUSINESS_CUSTOMERSBYID';
export const FETCH_BUSINESS_CUSTOMERSBYID_SUCCESS = 'FETCH_BUSINESS_CUSTOMERSBYID_SUCCESS';
export const FETCH_BUSINESS_CUSTOMERSBYID_FAILED = 'FETCH_BUSINESS_CUSTOMERSBYID_FAILED';
export const getBusinessDetails = (businessId) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/${businessId}`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: FETCH_BUSINESS_CUSTOMERSBYID,
        meta: { loading: true }
      },
      {
        type: FETCH_BUSINESS_CUSTOMERSBYID_SUCCESS,
        meta: (_action, state) => {
          const businessId = state.cases.get(BUSINESS_UUID);
          if (checkEmptyFieldValue(businessId)) {
            return { nextAction: getMarketingPreferences(businessId), loading: true };
          }
          return { loading: false };
        }
      },
      {
        type: FETCH_BUSINESS_CUSTOMERSBYID_FAILED,
        meta: { loading: false }
      }
    ]
  }
});

export const FETCH_MARKETING_PREFERENCES = 'FETCH_MARKETING_PREFERENCES';
export const FETCH_MARKETING_PREFERENCES_SUCCESS = 'FETCH_MARKETING_PREFERENCES_SUCCESS';
export const FETCH_MARKETING_PREFERENCES_FAILED = 'FETCH_MARKETING_PREFERENCES_FAILED';
export const getMarketingPreferences = (businessId) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/customers/${businessId}/marketconsent`,
    method: 'GET',
    headers: {
      'x-bpi-version': '0.8.0'
    },
    types: [
      {
        type: FETCH_MARKETING_PREFERENCES,
        meta: { loading: true }
      },
      {
        type: FETCH_MARKETING_PREFERENCES_SUCCESS,
        meta: { loading: false }
      },
      {
        type: FETCH_MARKETING_PREFERENCES_FAILED,
        meta: { loading: false }
      }
    ]
  }
});

export const updateCase = (nextAction) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current/${getQueryStringValueByName(
      CASE_ID
    )}/tasks/capture/actions/update`,
    method: 'PUT',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    body: (state) => updateCasePayload(state),
    types: [
      {
        type: UPDATE_CASE,
        meta: { loading: true }
      },
      {
        type: UPDATE_CASE_SUCCESS,
        meta: (_action, state) => nextAction(state)
      },
      {
        type: UPDATE_CASE_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});
